import Vue from "vue"

// initial state
const state = { schemas: {} }

const getters = {
  getSchema: state => name => {
    return state.schemas[name]
  }
}

const mutations = {
  ADD_SCHEMA: (state, payload) => {
    Vue.set(state.schemas, payload.name, payload.schema)
  },
  CLEAR_SCHEMAS: state => {
    state.schemas = {}
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
